// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1O7Lv","notes":"Notes_notes__3pMPe","note":"Notes_note__1RnEn","markdown":"Notes_markdown__3hMaZ"};